import axios from 'axios'

import * as TYPE from '../util/types'
import { rawAxiosGet } from '../../plugins/rawAxios'
import { googleMapsAPIKey } from '../util/values'
import { getSafeNestedObject } from '~/store/util/util'

const state = {
	userLookup: null,
	visitor_location: {}
}

const actions = {
	setUserLocation({ commit, getters, rootState }, payload) {
		let location = payload
		let shouldSendLocation = true
		if (getters.userIsAuthenticated) {
			if (rootState.Authentication.authUser.hasOwnProperty('last_location')) {
				if (rootState.Authentication.authUser.last_location !== null) {
					let lastLocation = rootState.Authentication.authUser.last_location
					let oldCity = null
					if (
						lastLocation.hasOwnProperty('location') &&
						lastLocation.location !== null
					) {
						let lastLoc = JSON.parse(lastLocation.location)
						if (lastLoc.hasOwnProperty('city')) {
							oldCity = lastLoc.city
						}
					}
					if (oldCity === location.city) {
						shouldSendLocation = false
					}
				}
			}
			if (shouldSendLocation) {
				axios.post('/api/v1/user/location_history/', location)
			}
		}
		let exact = location.exact
		delete location.exact
		commit(TYPE.SET_USER_PROP, {
			prop: 'last_location',
			value: { exact: exact, location: location }
		})
		commit(TYPE.SET_VISITOR_LOCATION, location)
	},
	fetchLocationByIP({ dispatch, commit, state, rootState, getters }) {
		let result = rawAxiosGet('https://api.ipgeolocation.io/ipgeo?apiKey=ab625822cfe34ef99abfd8593d4eb12e', {})
			.then(response => {
				let location = {
					exact: false,
					country: response.data.country_code3,
					state: response.data.state_prov,
					city: response.data.city,
					zipcode: response.data.zipcode,
					latitude: response.data.latitude,
					longitude: response.data.longitude
				}

				dispatch('setUserLocation', location)
			})
			.catch(error => {
				console.error(error)
			})
	},
	reverseGeocode({ dispatch, commit, state, rootState, getters }, payload) {
		let latitude = payload.coords.latitude
		let longitude = payload.coords.longitude

		if (!latitude || !longitude) {
			console.error('invalid longitude or latitude')
			return
		}

		let location = { latitude: latitude, longitude: longitude, exact: true }
		let latlng = { lat: parseFloat(latitude), lng: parseFloat(longitude) }
		var geocoder = new google.maps.Geocoder()

		geocoder.geocode({ location: latlng }, (results, status) => {
			if (results.length > 0) {
				let components = results[0].address_components
				if (components !== null) {
					for (var i = 0; i < components.length; i++) {
						let type = components[i].types[0]
						if (type === 'neighborhood') {
							location['neighborhood'] = components[i].long_name
						} else if (type === 'locality') {
							location['city'] = components[i].long_name
						} else if (type === 'administrative_area_level_2') {
							location['county'] = components[i].long_name
						} else if (type === 'administrative_area_level_1') {
							location['state'] = components[i].long_name
						} else if (type === 'country') {
							location['country'] = components[i].long_name
						} else if (type === 'postal_code') {
							location['zipcode'] = components[i].long_name
						}
					}
				}
			}
			dispatch('setUserLocation', location)
		})
	}
}
const mutations = {
	[TYPE.SET_VISITOR_LOCATION]: (state, payload) => {
		state.visitor_location = payload
	}
}
const getters = {
	getVisitorLocation: state => state.visitor_location
}

export default {
	state,
	getters,
	mutations,
	actions
}
